import { useTheme } from "../../../hooks/useTheme";


import React, { useState } from 'react'

import { AppColumn, AppRow, Wrap } from "../../UI/Layouts";
import { SizedBox } from "../../UI/Sizes";
import AppText from "../../UI/Texts/AppTexts";
import { useResponsive } from "../../UI/ResponsiveContext";
import { SelectOrUploadFile } from "../../UI/UploadFile";
import { DOCUMENT_IDS, CANDIDATE_DOCUMENT_IDS, getDocumentNameType } from '../../../utils/Constants/documentIDs';
import { AppPrimaryButton, CloseCircleButton, PrimaryChip } from '../../UI/CustomButtons';
import AppPrimaryTextfield from '../../UI/TextInput';
import { t } from 'i18next';
import { showToast } from '../../../redux/Snackbar/SnackbarActions';
import { connect } from 'react-redux';


const UploadProfileDocument = ({ closeModal, onDone, type = 'none', showToast }) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();

    const documentTypes = CANDIDATE_DOCUMENT_IDS;

    const [newLocalFile, setNewLocalFile] = useState(null);
    const [serverData, setServerData] = useState(null);

    const [fileName, setFileName] = useState(null);
    const [selectedDocumentType, setSelectedDocumentType] = useState(DOCUMENT_IDS.CV);


    return (<AppColumn style={{
        paddingTop: theme.spacing.elementPadding,
        paddingLeft: isMobile ? theme.spacing.contentElementPadding : theme.spacing.contentElementPadding,
        paddingRight: isMobile ? theme.spacing.contentElementPadding : theme.spacing.contentElementPadding,
        paddingBottom: isMobile ? theme.spacing.contentElementPadding : theme.spacing.contentElementPadding,
        height: isMobile && '100vh',
    }}>
        <SizedBox height={theme.spacing.elementPadding} />
        <AppRow crossAxisAlignment={'center'} mainAxisAlignment={'space-between'}>
            <AppText.SubHeading fontWeight={600}>{t('profile.add_document.title')}</AppText.SubHeading>
            <CloseCircleButton onClick={closeModal} />
        </AppRow>
        <SizedBox height={theme.spacing.contentElementPadding} />

        <AppPrimaryTextfield value={fileName}
            onChange={(v) => {
                setFileName(v)
            }}
            capitalizedText="sentence"
            labelText={t('profile.add_document.document_name')}
            hintText={t('profile.add_document.document_name.hint_text')}
        />

        <SizedBox height={theme.spacing.contentElementPadding} />

        <SelectOrUploadFile
            id={'file'}
            onFileChange={(file, serverData) => {
                setNewLocalFile(file);
                setServerData(serverData);


                if (file && !fileName) {
                    setFileName(file.name);
                } else if (serverData && !fileName) {
                    setFileName(serverData?.fileName);
                    setSelectedDocumentType(serverData?.type ?? DOCUMENT_IDS.CV);
                }
            }}
            type={type}
            title={t('profile.add_document.select_file')}
        />

        <SizedBox height={theme.spacing.contentElementPadding} />
        <AppText.Caption>
            {t('profile.add_document.select_document_type')}
        </AppText.Caption>

        <SizedBox height={theme.spacing.contentElementPadding} />

        <Wrap>
            {documentTypes.map((type) => {
                const selected = selectedDocumentType === type;

                const nameType = getDocumentNameType(type)

                return (<PrimaryChip
                    selected={selected}
                    secondary
                    text={nameType}
                    onClick={() => {
                        setSelectedDocumentType(type);
                    }}
                />)
            })}

        </Wrap>

        <SizedBox height={theme.spacing.contentElementPadding} />

        <AppRow mainAxisAlignment={'center'}>
            <AppPrimaryButton
                loading={false}
                size={isMobile ? "large" : "big"}
                style={{
                    width: '100%',
                    borderRadius: theme.radius.button,
                }}
                onClick={() => {

                    if (!newLocalFile && !serverData) {
                        showToast(t('select_file_to_upload'), {
                            type: 'warning',
                        });
                        return;
                    }


                    const fileData = {
                        localFile: newLocalFile,
                        serverData: newLocalFile ? null : Object.assign({ ...serverData }, {
                            type: selectedDocumentType,
                        }),
                        fileName: fileName,
                        type: selectedDocumentType,
                    }

                    onDone(fileData);
                }}
            >{t('save')}
            </AppPrimaryButton>

        </AppRow>
    </AppColumn>)
}

export default connect(null, { showToast })(UploadProfileDocument);